import { render, staticRenderFns } from "./FilterTab.vue?vue&type=template&id=3205c950&scoped=true"
import script from "./FilterTab.vue?vue&type=script&lang=ts"
export * from "./FilterTab.vue?vue&type=script&lang=ts"
import style0 from "./FilterTab.vue?vue&type=style&index=0&id=3205c950&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3205c950",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3205c950')) {
      api.createRecord('3205c950', component.options)
    } else {
      api.reload('3205c950', component.options)
    }
    module.hot.accept("./FilterTab.vue?vue&type=template&id=3205c950&scoped=true", function () {
      api.rerender('3205c950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/FilterTab.vue"
export default component.exports